import { grey } from "@mui/material/colors";
import { createTheme } from "@mui/material/styles";

// Shared color primitives, reused across `lightMode` and `scoreUrlTokens`.
const brandRed = "#FF1400"; // == rgb(255, 20, 0)
const brandBlue = "#0025FF";

const customFontSizes = {
    fontSize64: "4em",
    fontSize36: "2.25em",
    fontSize28: "1.75em",
    fontSize24: "1.5em",
    fontSize20: "1.25em",
    fontSize16: "1em",
    fontSize14: "0.875em",
    fontSize12: "0.75em",
    fontSize10: "0.625em",
}

const customThemeColors = {
    disabledArrowButton: grey[600]
}

export const lightMode = createTheme({
    palette: {
        ...customFontSizes,
        ...customThemeColors,
        mode: 'dark',
        background: {
            default: '#000000',
            paper: '#000000',
        },
        primary: {
            main: "#FFFFFF",
        },
        error: {
            main: "#F00",
        },
        secondary: {
            main: brandBlue,
        }
    },
    typography: {
        allVariants: {
            fontStyle: "italic",
            color: "#FFFFFF",
            fontFamily: "HelveticaNeue"
        },
    },
    components: {
        MuiCssBaseline: {
            styleOverrides: {
                body: {
                    backgroundColor: '#000000',
                }
            }
        },
        MuiLinearProgress: {
            styleOverrides: {
                root: {
                    height: 10,
                    '&.MuiLinearProgress-determinate': {
                        backgroundColor: '#00000080',
                    },

                }
            }
        },
        MuiButton: {
            styleOverrides: {
                root: {
                    backgroundColor: brandRed,
                }
            }
        },
        MuiInput: {
            styleOverrides: {
                root: {
                    color: "#FFFFFF",
                    borderColor: "#FFFFFF",
                    '::before': {
                        borderBottomColor: '#FFFFFF'
                    }
                }
            }
        },
    },
});

// ScoreUrl (Artist / Weekly URLs console) design tokens. The console's page shell, nav, and
// table moved to a light red/white/blue theme (see scoreUrlStyle.jsx's `suLight`); the colors
// below are what's still actively used — dark-theme-only entries (page/header background,
// neutral grays, extra accent shades) were removed once nothing referenced them anymore.
export const scoreUrlTokens = {
    colors: {
        primary: brandRed, // same red as lightMode's MuiButton override
        accent400: "#5c73ff", // focus-visible outline color
        editBlue: "#38bdf8",
        viewPurple: "#c084fc", // "View" action icon (Weekly URLs table)
        success: "#22c55e", // "Active" status icon (Artist table)
        white: "#ffffff",
    },
    font: {
        family: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    },
    fontSize: {
        11: 11,
        12: 12,
        13: 13,
        15: 15,
        18: 18,
        20: 20,
    },
    radius: {
        control: 5,
        nav: 6,
    },
    space: {
        1: 4,
        2: 8,
        3: 12,
        4: 16,
        5: 24,
    },
};